export function initializeDropdown(dropdownElement) {
  if (dropdownElement.dataset.initialized === "true") return;
  dropdownElement.dataset.initialized = "true";

  const selectedTextElement = dropdownElement.querySelector(
    ".dropdown-select > span",
  );
  const hiddenInput = document.getElementById(dropdownElement.dataset.input);
  const dropdownOptions = dropdownElement.querySelector(".dropdown-options");
  const selectTrigger = dropdownElement.querySelector(".dropdown-select");

  if (selectTrigger) {
    selectTrigger.addEventListener("click", (e) => {
      e.stopPropagation();
      document
        .querySelectorAll(".custom-dropdown.open")
        .forEach((openDropdown) => {
          if (openDropdown !== dropdownElement) {
            openDropdown.classList.remove("open");
          }
        });
      dropdownElement.classList.toggle("open");
    });
  }

  if (dropdownOptions) {
    dropdownOptions.addEventListener("click", (e) => {
      const target = e.target;
      if (target && target.tagName === "A") {
        e.preventDefault();
        const value = target.dataset.value;
        const text = target.textContent;

        if (selectedTextElement) {
          selectedTextElement.textContent = text;
          const i18nKey = target.getAttribute("data-i18n");
          if (i18nKey) {
            selectedTextElement.setAttribute("data-i18n", i18nKey);
          } else {
            selectedTextElement.removeAttribute("data-i18n");
          }
        }
        if (hiddenInput) {
          hiddenInput.value = value;
          try {
            const event = new Event("change");
            hiddenInput.dispatchEvent(event);
          } catch {
            // Silently ignore event dispatch errors
          }
        }
        dropdownElement.classList.remove("open");

        const changeEvent = new CustomEvent("dropdown-change", {
          detail: { dropdownId: dropdownElement.id, value, text },
        });
        dropdownElement.dispatchEvent(changeEvent);
      }
    });
  }
}

// --- Auto-convert Standard Selects to Premium Custom Dropdowns ---
export function convertSelectsToCustomDropdowns() {
  const selects = document.querySelectorAll(
    "select.form-select-premium, select.premium-select, select.form-select, select.premium-select-custom",
  );
  selects.forEach((select) => {
    if (select.dataset.converted) return;

    const container = document.createElement("div");
    container.className = "custom-dropdown";
    if (select.id) container.id = select.id + "-dropdown";

    const selectedOption = select.options[select.selectedIndex];
    const selectedText = selectedOption ? selectedOption.textContent : "Select...";
    const i18nKey = selectedOption ? selectedOption.getAttribute("data-i18n") : "";

    container.innerHTML = `
        <div class="dropdown-select">
          <span ${i18nKey ? `data-i18n="${i18nKey}"` : ""}>${selectedText}</span>
          <span class="arrow">&#9662;</span>
        </div>
        <div class="dropdown-options">
          ${Array.from(select.options)
            .map(
              (opt) => `
            <a href="#" data-value="${opt.value}" ${
              opt.getAttribute("data-i18n")
                ? `data-i18n="${opt.getAttribute("data-i18n")}"`
                : ""
            }>
              ${opt.textContent}
            </a>
          `,
            )
            .join("")}
        </div>
      `;

    // Hide original select but keep it for form submission and events
    select.style.display = "none";
    select.dataset.converted = "true";
    select.parentNode.insertBefore(container, select.nextSibling);

    // Initialize the new custom dropdown
    initializeDropdown(container);

    // Listen for changes on the custom dropdown to sync back to select
    container.addEventListener("dropdown-change", (e) => {
      select.value = e.detail.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
}
